import DropdownIcon from 'icon/dropdown'
import { useState } from 'react'
import NavItem from './nav-item'

function NavDropdown({ label, path, icon, children }) {
  const [toggleNav, setToggleNav] = useState(false)

  const sa_bg_color = 'white'
  const sa_text_color = '#0a4d85'
  const s_text_color = 'white'

  return (
    <li>
      <button
        type='button'
        class='flex items-center w-full p-2 text-base text-white transition duration-75 rounded-lg group'
        onClick={() => setToggleNav(!toggleNav)}
        onMouseEnter={(e) =>
          e.currentTarget.setAttribute(
            'style',
            `background-color: ${sa_bg_color}; color: ${sa_text_color}`
          )
        }
        onMouseLeave={(e) =>
          e.currentTarget.setAttribute(
            'style',
            `background-color: 'transparent'; color: ${s_text_color}`
          )
        }
      >
        {icon}
        <span class='flex-1 ms-3 text-left rtl:text-right whitespace-nowrap'>
          {label}
        </span>
        <DropdownIcon
          className={`${
            toggleNav ? 'rotate-180' : ''
          } transition-all duration-300`}
        />
      </button>
      {toggleNav && (
        <ul id='dropdown-example' class='py-2 space-y-2 mx-3'>
          {children.map((item) => (
            <NavItem {...item} />
          ))}
        </ul>
      )}
    </li>
  )
}

export default NavDropdown
